import { useQueryClient } from "@tanstack/react-query";
import { PropertyFinishing } from "../../types";
import { EditFinishingInfoDTO } from "../../dtos";
import { editFinishingInfo } from "../../api";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";

export function useEditPropertyFinishingInfo() {
  const queryClient = useQueryClient();

  const mutationEditProperty = useDomainMutation<
    PropertyFinishing,
    { response?: { data?: { message?: string } } },
    { uid: string; data: EditFinishingInfoDTO }
  >({
    mutationFn: ({
      uid,
      data,
    }: {
      uid: string;
      data: EditFinishingInfoDTO;
    }) => {
      return editFinishingInfo(uid, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutationEditProperty;
}
